import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, Redirect} from 'react-router';
import Header from './Header';
import {generateRoutePath} from 'epic-common/src/route';
import RegisterActions from '../../actions/RegisterActions';
import queryString from 'query-string';

class IosGameConfirm extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        location: PropTypes.object,
        title: PropTypes.string,
        isLoggedIn: PropTypes.bool
    };

    componentDidMount() {
        RegisterActions.entitleUser();
    }

    render() {
        const {content, title, isLoggedIn} = this.props;
        const confirmData = content.confirm || [];
        if (!isLoggedIn) {
            const query = queryString.parse(this.props.location.search) || {};
            const code = query.code && typeof query.code === 'string' ? query.code.replace(/-/g, '').substring(0, 20) : undefined;
            query.code = code;
            query.mode = query.mode || undefined;
            return <Redirect to={generateRoutePath(`/mobile/download?${queryString.stringify(query)}`)} />;
        }
        return (
            <div className="confirm-page">
                <div className="container-fluid content-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <div className="content">
                                    <Header title={title} />
                                    <div>
                                        <h2>{confirmData[0].title}</h2>
                                        {confirmData[0].description ? (
                                            <div dangerouslySetInnerHTML={{__html: confirmData[0].description}} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="heroes" />
                </div>
            </div>
        );
    }
}

export default withRouter(IosGameConfirm);
